import actions from '../actions/tests';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
